import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "Contact",
    component: () => (__SERVER__ ? require("./contact-view") : import("./contact-view"))
});

export default definition;
